import { Controller } from '@hotwired/stimulus';
import { jquery } from 'utils/jquery';

export default class extends Controller {
  static targets = ['languageSelect']

  declare languageSelectTarget: HTMLSelectElement;

  connect(): void {
    const $ = jquery();

    if ($) {
      let $languageSelect = $(this.languageSelectTarget).select2();
      $languageSelect.on('change', this.changeLanguage.bind(this));
    } else {
      // select2 fires only jQuery events — without jQuery, fall back to a plain
      // native listener so voters can still switch language (Rollbar #3267).
      this.languageSelectTarget.addEventListener('change', this.changeLanguage.bind(this));
    }
  }

  changeLanguage(event: Event): void {
    const selectedLocale = (event.target as HTMLSelectElement).value;

    const url = new URL(window.location.href);
    url.searchParams.set('locale', selectedLocale);
    window.location.href = url.toString();
  }
}
